export const setupMobileMenu = (): void => {
  const menu = document.querySelector("#mobile-menu") as HTMLElement

  const menuOpenButton = document.querySelector("#mobile-menu-button") as HTMLButtonElement
  menuOpenButton.addEventListener("click", () => openMobileMenu(menu))
  const menuCloseButton = document.querySelector("#mobile-menu-close") as HTMLButtonElement
  menuCloseButton.addEventListener("click", () => closeMobileMenu(menu))
}

const openMobileMenu = (menu: HTMLElement): void => {
  document.body.style.overflowY = "hidden"
  menu.style.height = "100dvh"
}

const closeMobileMenu = (menu: HTMLElement): void => {
  document.body.style.overflowY = "auto"
  menu.style.height = "0vh"
}
